module.exports = __webpack_public_path__ + "static/img/ios_ja.ae060117.png";